<template>
  <div>
    <div class="voucher-new_container input-forms">
      <modal
        ref="alertVoucherToInclude"
        template="question"
        ref-name="alertVoucherToInclude"
        title="Voucher interlaboratorial"
        first-button-text="Não"
        second-button-text="Sim, Cadastrar"
        @first-cta="closeModalVoucher"
        @second-cta="createVoucher"
      >
        <p>Você ainda possui {{ examsLeft }} exame<span v-if="examsLeft > 1">s</span>a incluir.</p>
        <p>Após fechamento não será mais possível a inclusão.</p>
        <p class="bold">
          Deseja cadastrar com apenas {{ getSelectedVoucherExams.length }}?
        </p>
      </modal>

      <modal
        ref="transferModal"
        template="loading"
        ref-name="transferModal"
        title="Aguarde"
      >
        <p>Salvando OS...</p>
      </modal>

      <subheader title="Voucher interlaboratorial" />
      <div class="voucher-new__subtitle width-responsiveness">
        <p>O Álvaro disponibiliza <span>1 voucher mensal</span> para seu laboratório.</p>
        <p>Com ele é possível enviar até <span>5 exames</span> de teste, para aferição de seus equipamentos.</p>
      </div>
      <div class="voucher-new__patient width-responsiveness">
        <card-form class="cursor-blocked">
          <md-layout
            slot="collapsed"
            class="collapsed-container card-form--collapsed"
            :md-gutter="24"
            md-flex="100"
          >
            <md-layout
              md-flex="100"
              md-flex-medium="100"
            >
              <md-tooltip md-delay="400">
                Os dados do paciente são fictícios.
                <br>Não é permitido alterar.
              </md-tooltip>
              <h2
                id="patientFormTitle"
                class="voucher-new__patient__title voucher-new__patient__title-collapsed title-main"
              >
                Dados do Paciente
              </h2>
            </md-layout>
            <md-layout
              class="collapsed__item"
              md-flex="35"
            >
              <div class="md-input-container md-theme-default">
                <h3>Nome do paciente</h3>
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Os dados do paciente são fictícios.
                  <br>Não é permitido alterar.
                </md-tooltip>
                <p :title="patient.name">
                  {{ patient.name }}
                </p>
              </div>
            </md-layout>
            <md-layout
              class="collapsed__item"
              md-flex="10"
            >
              <div class="md-input-container md-theme-default">
                <h3>Idade</h3>
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Os dados do paciente são fictícios.
                  <br>Não é permitido alterar.
                </md-tooltip>
                <p>{{ patient.age }}</p>
              </div>
            </md-layout>
            <md-layout
              class="collapsed__item"
              md-flex="15"
            >
              <div class="md-input-container md-theme-default">
                <h3>Data de nascimento</h3>
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Os dados do paciente são fictícios.
                  <br>Não é permitido alterar.
                </md-tooltip>
                <p>{{ patient.birthDate }}</p>
              </div>
            </md-layout>
            <md-layout
              class="collapsed__item"
              md-flex="15"
            >
              <div class="md-input-container md-theme-default">
                <h3>Sexo</h3>
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Os dados do paciente são fictícios.
                  <br>Não é permitido alterar.
                </md-tooltip>
                <p>{{ patient.gender.label }}</p>
              </div>
            </md-layout>
            <md-layout
              class="collapsed__item"
              md-flex="15"
            >
              <div class="md-input-container md-theme-default">
                <h3>
                  <template v-if="!toggle.covax">
                    Código OS LIS
                  </template>
                  <template v-else>
                    Requisition Number
                  </template>
                </h3>
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Os dados do paciente são fictícios.
                  <br>Não é permitido alterar.
                </md-tooltip>
                <p :title="patient.osIdLis">
                  {{ patient.osIdLis }}
                </p>
              </div>
            </md-layout>
          </md-layout>
        </card-form>
      </div>

      <div
        id="examSearchContainer"
        class="voucher-new__exam width-responsiveness"
      >
        <md-layout
          :md-gutter="20"
          md-flex="100"
        >
          <md-layout md-flex="80">
            <h2
              id="examFormTitle"
              class="voucher-new__exam__title"
            >
              Exames disponíveis:
              <span>{{ examsLeft }}</span>
              <span v-if="!isVoucherInactive">(você não possui vouchers disponíveis)</span>
            </h2>
          </md-layout>
          <md-layout
            md-flex="20"
            class="voucher-new__cta"
          >
            <button
              v-if="(examsLeft === 5 && isVoucherInactive) || !isVoucherInactive"
              id="btnNewSaveDisabled"
              disabled="true"
              class="btn btn-medium btn-primary orders-new__exam__save-button"
              @click="openModalVoucher()"
            >
              <md-tooltip
                v-if="isVoucherInactive"
                md-direction="top"
              >
                Você ainda não selecionou
                <br>nenhum exame.
              </md-tooltip>Cadastrar Aferição
            </button>
            <button
              v-else
              id="btnNewSaveEnabled"
              class="btn btn-medium btn-primary orders-new__exam__save-button"
              @click="openModalVoucher()"
            >
              Cadastrar Aferição
            </button>
          </md-layout>
        </md-layout>
        <voucher-exams-new :exams-left="examsLeft" />
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader'
import notify from '@/api/notification'
import CardForm from '@/components/common/CardForm'
import VoucherExamsNew from '@/components/Exams/VoucherExamsNew'
import { mask } from 'vue-the-mask'
import { mapActions, mapGetters } from 'vuex'
import { ORDER_STATE_FAIL, ORDER_STATE_PENDING_TRANSMISSION } from '@/enums'

export default {
  name: 'VoucherNew',
  components: {
    subheader: SubHeader,
    'card-form': CardForm,
    'voucher-exams-new': VoucherExamsNew
  },
  directives: {
    mask: mask
  },
  data: () => {
    return {
      patient: {
        idLis: '',
        name: 'Controle - Voucher',
        age: '00',
        birthDate: '01/01/1990',
        gender: {
          value: 'M',
          label: 'Masculino'
        },
        osIdLis: '',
        collectDate: null,
        collectTime: '',
        doctor: {
          name: '',
          id: '',
          state: ''
        },
        comments: ''
      },
      availableExams: 5
    }
  },
  computed: {
    ...mapGetters(['profile', 'getSelectedVoucherExams', 'isVoucherInactive', 'toggle']),
    examsLeft: function () {
      return this.availableExams - this.getSelectedVoucherExams.length
    }
  },
  watch: {
    isVoucherInactive: function () {
      this.checkActiveVoucher()
    }
  },
  created() {
    this.setAvailableExamsForVoucher()
    this.getInactiveVoucher()
    this.checkActiveVoucher()
  },
  beforeDestroy() {
    this.clearExamList()
  },
  methods: {
    ...mapActions(['addPatient', 'createOs', 'setAvailableExamsForVoucher', 'getInactiveVoucher', 'clearExamList', 'setOrderShowOff']),
    checkActiveVoucher() {
      if (!this.isVoucherInactive) {
        this.availableExams = 0
      } else {
        this.availableExams = 5
      }
    },
    closeTransferDialog() {
      this.$refs.transferModal.close()
    },
    openTransferDialog() {
      this.$refs.transferModal.open()
    },
    openModalVoucher() {
      if (this.examsLeft < 5 && this.examsLeft >= 1) {
        this.$refs.alertVoucherToInclude.open()
      } else {
        this.createVoucher()
        this.$analytics.pushAnalyticsEvent('ga-event', {
          category: 'Voucher Interlaboratorial',
          action: 'Inclusão de voucher interlaboratorial',
          'id-user': this.profile.id,
          'id-lab': this.profile.id_laboratory,
          'name-lab': this.profile.laboratoryName
        })
      }
    },
    closeModalVoucher() {
      this.$refs.alertVoucherToInclude.close()
    },
    createVoucher() {
      this.closeModalVoucher()
      this.openTransferDialog()
      let param = {
        id: null,
        isVoucher: true
      }
      this.addPatient(this.patient)
      this.createOs(param)
        .then(response => {
          this.closeTransferDialog()
          this.$router.push('/orders?filterBy=' + ORDER_STATE_PENDING_TRANSMISSION + '&filterBy=' + ORDER_STATE_FAIL)
          this.setOrderShowOff(false)
        })
        .catch(() => {
          this.closeTransferDialog()
          notify({
            title: 'AVISO:',
            message: 'Não foi possivel salvar a Ordem de Serviço.'
          })
        })
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/mixins';
@import '../../../static/stylesheets/variables';

//Orders New Page Styles
.voucher-new_container {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);

  .priority {
    div {
      display: none;
    }
  }

  .card-form__container {
    transition: min-height 600ms, opacity 600ms;
    opacity: 1;
    min-height: 237px;
    border-radius: 6px;

    .collapsed__list__item__edit-button {
      position: absolute;
      right: 0px;
      margin-top: 3px;
      padding: 10px;
      bottom: 20px;

      &>.md-icon:not(.md-icon-delete) {
        position: static;
        margin: 0;
        line-height: 16px;
        color: #c2c2c2;
      }
    }

    .card-form__delete-button {
      position: absolute;
      top: 5px;
      right: 10px;
      color: #c2c2c2;
    }

    &.card-form--collapsed {
      transition: min-height 600ms, opacity 600ms;
      min-height: 90px;

      &.exam__container {
        .collapsed__list__item__edit-button {
          position: absolute;
          right: 37px;
          margin-top: 3px;

          &>.md-icon:not(.md-icon-delete) {
            position: static;
            margin: 0;
            line-height: 16px;
            color: #c2c2c2;
          }
        }

        .collapsed__list__item__delete-button {
          position: absolute;
          margin-top: 3px;
          right: 0;
          margin-right: 0px;
          padding: 10px;
          bottom: 20px;

          &>.md-icon {
            top: -4px;
          }
        }
      }

      .submit-button,
      .form-container {
        animation-duration: 700ms;
        animation-name: fadeout;
        display: none;
      }

      .collapsed-container {
        opacity: 1;
        display: flex;
        animation-name: fadein;
        animation-duration: 700ms;

        .collapsed__item {
          .md-input-container {
            flex: 1;
            flex-direction: column;
            margin: 0 15px 0;
            padding-top: 0;

            &:after {
              height: 0;
            }
          }

          h3 {
            font-size: 12px;
            color: #858585;
            font-weight: normal;
            white-space: nowrap;
          }

          p {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 90%;
            color: #858585;
            font-size: 16px;

            &.material {
              text-transform: capitalize;
            }
          }

          input {
            font-size: 16px;
          }
        }
      }
    }

    .form-container {
      animation-name: fadein;
      animation-duration: 700ms;
      display: flex;

      .required-fields-label {
        position: absolute;
        right: 5px;
        top: -30px;
        font-size: 12px;
        color: #a80009;
      }

      .tab-label {
        position: absolute;
        right: 180px;
        top: -30px;
        font-size: 12px;
        color: black;

        strong {
          font-weight: 700;
        }
      }

      .md-layout {
        .md-input-container {
          margin: 0 0 17px;
        }
      }

      .md-input-container,
      .md-input-container.md-input-focused {
        .md-icon {
          color: #c2c2c2;
        }
      }
    }

    .collapsed-container {
      animation-name: fadeout;
      animation-duration: 700ms;
      display: none;
    }
  }

  .cursor-blocked {
    cursor: not-allowed;
  }

  .voucher-new__patient {
    margin-top: 30px;

    .form-container {
      .md-gutter-24:not(.md-column) {
        margin-right: 0;
        margin-left: 0;
      }
    }

    .collapsed-container {
      .collapsed__list {
        display: flex;

        &__item {
          margin: 0 15px 0;

          &:last-child {
            margin-left: 5px;
          }
        }

        .collapsed__title {
          font-size: 12px;
          color: #858585;
          font-weight: normal;
        }

        .collapsed__text {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 16px;
          color: #303030;
          margin-top: 2px;
          letter-spacing: normal;
        }

        input {
          font-size: 16px;
        }
      }
    }

    @media all and (-ms-high-contrast: none) {
      .md-layout {
        .md-layout {
          display: table;
        }
      }
    }

    /* .multiselect__element:nth-child(1) {
        cursor: not-allowed;
        display: none;
      } */
  }

  .voucher-new {
    &__cta {
      align-content: center;
      align-items: center;

      .btn-primary:disabled {
        background-color: #d9d9d9;
      }
    }

    &__subtitle {
      margin-top: 140px;

      p {
        color: #828282;

        span {
          color: #7f1a54;
        }
      }
    }

    &__exam {
      min-height: 400px;

      &__save-button {
        width: 182px;

        &__icon-save {
          margin: 0 7px 0 0;
          width: 16px;
          height: 15px;
          min-height: 15px;
          min-width: 16px;
        }
      }

      &__save-reload-button {
        width: 263px;
        margin-right: 20px;

        &__icon-reload {
          margin: 0 7px 0 0;
          width: 16px;
          height: 15px;
          min-height: 15px;
          min-width: 16px;
        }
      }
    }

    &__patient__title {
      margin: 5px 0 20px;

      &-collapsed {
        margin-left: 15px;
      }
    }

    &__exam__title {
      margin: 34px 0 31px;
      font-size: 22px;
      font-weight: 400;
      letter-spacing: -0.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 1.09;

      span {
        color: #7f1a54;
        font-weight: bolder;
        padding-left: 3px;
      }
    }

    &__observation-container {
      width: 100%;

      .md-input {
        overflow-y: hidden !important;
        overflow: hidden;
        -ms-overflow-x: hidden;
        -ms-overflow-y: hidden !important;
        max-height: none;
      }
    }

    &__footer {
      margin: 36px 0;

      .endButton {
        flex-wrap: nowrap;
      }
    }
  }

  .exam-voucher {
    &__curves {
      display: flex;
      flex-direction: column;
      padding: 0 12px;

      &__items {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        height: 170px;
      }

      &__item {
        width: 10%;
        padding: 10px;
        display: flex;
        align-items: center;

        &:nth-child(6n) {
          width: 10%;
        }

        label.exam-voucher__curves__item__label {
          font-size: 13px;
          text-align: left;
          padding-left: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-top: -5px;
          margin-bottom: 0;
          cursor: pointer;
          font-weight: 500;
          letter-spacing: 0.4px;
          color: $label-color;
        }
      }
    }
  }

  .advanced-select__container {
    position: absolute;
    width: 100%;
  }

  #txtNewSampleQuantity {
    pointer-events: none;
    color: rgba(0, 0, 0, 0.38);
    cursor: not-allowed;
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }

  99% {
    opacity: 0;
  }

  100% {
    display: none;
  }
}

@keyframes fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.voucher-new__exam__cancel-button {
  width: 182px;
}

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {

  //Prevent z-index overlapping in the patient gender combo
  #patientGender {
    z-index: 3;
  }
}

.IE {
  .new-exam {
    .search-results__exams {
      .exam__container {
        .exam-item__details.md-flex-25 {
          min-width: 17%;
          max-width: 18.3%;
        }
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    .new-exam {
      .search-results__exams {
        .paternity-exam {
          .collapsed__item {
            padding: 0;
          }

          .md-flex-35 {
            min-width: 10%;

            .md-theme-default {
              width: 240px;
              margin-right: 0;
            }
          }
        }

        .exam__container {
          .exam-item__details.md-flex-25 {
            min-width: 17%;
            max-width: 21.7%;
          }
        }
      }
    }

    .voucher-new_container .card-form__container.card-form--collapsed .collapsed-container .collapsed__item p {
      width: 100%;
    }
  }
}
</style>
